import { Link, NavLink } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div
        className="footer__bg"
        style={{ backgroundImage: 'url(/footer-bg.png)' }}
      />
      <div className="footer__container">
        <div className="footer__cta-bar">
          <h2 className="footer__cta-heading">Payments that settle in <span className="footer__cta-accent">seconds.</span></h2>
          <a href="#contact" className="footer__cta-btn">
            Book a discovery call
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M2 7.5H13M13 7.5L8.625 3.125M13 7.5L8.625 11.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
        <div className="footer__links">
          <div className="footer__brand">
            <img src="/settlor-logo.png" alt="settlor.money" width="124" height="42" className="footer__logo" />
            <p className="footer__brand-desc">One trusted rail for payouts, reconciliation and settlement, built for Indian banks, fintechs and ISPs.</p>
            <div className="footer__badges">
              <span className="footer__badge">RBI-aligned</span>
              <span className="footer__badge">PCI-DSS L1</span>
              <span className="footer__badge">ISO 27001</span>
              <span className="footer__badge">PMLA 2002</span>
            </div>
          </div>
          <div className="footer__col">
            <h4 className="footer__col-title">Product</h4>
            <ul className="footer__col-list">
              <li><Link to="/payout">Payout</Link></li>
              <li><a href="#reconciliation">Reconciliation</a></li>
              <li><a href="#merchant">Merchant Portal</a></li>
              <li><Link to="/partner">Partner program</Link></li>
            </ul>
          </div>
          <div className="footer__col">
            <h4 className="footer__col-title">Company</h4>
            <ul className="footer__col-list">
              <li><NavLink to="/about">About</NavLink></li>
              <li><NavLink to="/contact">Contact</NavLink></li>
              <li><NavLink to="/blog">Blog</NavLink></li>
              <li><NavLink to="/faq">FAQ</NavLink></li>
            </ul>
          </div>
          <div className="footer__col">
            <h4 className="footer__col-title">Legal</h4>
            <ul className="footer__col-list">
              <li><Link to="/legal/terms-of-use">Terms of Use</Link></li>
              <li><Link to="/legal/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/legal/refund-and-cancellations">Refund &amp; Cancellations</Link></li>
              <li><Link to="/legal/grievance-redressal">Grievance Redressal</Link></li>
              <li><Link to="/legal/aml-kyc-policy">AML &amp; KYC Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer__bottom">
          <p>Copyright © 2026 settlor.money. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
